import * as React from "react";
import { recognitionPhotos } from "../../constants/photos";

import styles from "./Recognition.module.css";
import { HoverableImage } from "../../components/HoverableImage/HoverableImage";

const Recognition = () => {
  const gallery = recognitionPhotos.map((image) => (
    <HoverableImage
      src={image.src}
      infoTitle={image.infoTitle}
      infoDescription={image.infoDescription}
    />
  ));
  return (
    <div className={styles.recognitionContainer}>
      <div className={styles.textContainer}>
        <div className={styles.gmaro}>
          <img className={styles.logo} src="/ifflogo.png" loading={"lazy"}></img>
          <span>International Flavors & Fragrances × Royal College of Art Competition Winner '25-'26 - Team Leader and Concept Director </span>
        </div>
        <div className={styles.gmaro}>
          <img className={styles.logo} src="/inplogo.png" loading={"lazy"}></img>
          <span> Fashion Cultural Exhibition - Sponsored by Romania's National Institute of Heritage '26 </span>
        </div>
        <div className={styles.gmaro}>
          <img className={styles.logo} src="/kingsfoundationlogo.png" loading={"lazy"}></img>
          <span>Meeting with HM The King - The King's Foundation Alumni at LFW '25 </span>
        </div>
        <div className={styles.gmaro}>
          <img className={styles.logo} src="/dazedlogo.png" loading={"lazy"}></img>
          <span>Interview in Dazed - FlaviaNís Interview '25 </span>
        </div>
        <div className={styles.gmaro}>
          <img className={styles.logo} src="/kingsfoundationlogo.png" loading={"lazy"}></img>
          <span>Meeting with HM The King - Dumfries House '24 </span>
        </div>
        <div className={styles.gmaro}>
          <img className={styles.logo} src="/voguebusinesslogo.png" loading={"lazy"}></img>
          <span>Interview in Vogue Business - The Modern Artisan '24 </span>
        </div>
        <div className={styles.gmaro}>
          <img className={styles.logo} src="/gmaro.jpg" loading={"lazy"}></img>
          <span>GMARO Magazine Aug '23</span>
        </div>
        <div className={styles.collective}>
          <img
            className={styles.logo}
            src="/gfwlogo.jpg"
            loading={"lazy"}
          ></img>
          <span>Graduate Fashion Week Collective Fashion Show '23</span>
        </div>
        <div className={styles.gfw}>
          <img
            className={styles.logo}
            src="/gfwlogo.jpg"
            loading={"lazy"}
          ></img>
          <span>Talent of Tomorrow Photoshoot '23</span>
        </div>
        <div className={styles.gmaro}>
          <img className={styles.logo} src="/gmaro.jpg" loading={"lazy"}></img>
          <span>GMARO Magazine Aug '22</span>
        </div>
        <div className={styles.dallesgo}>
          <img
            className={styles.logo}
            src="/dallesgo.jpg"
            loading={"lazy"}
          ></img>
          <span>Dalles Go Fashion Show '19</span>
        </div>
      </div>
      <div className={styles.imagesContainer}>
        <div className={styles.galleryContainer}>
          <div className={styles.desktopGalleryContainer}>{gallery}</div>
          <div className={styles.mobileGalleryContainer}>{gallery}</div>
        </div>
      </div>
    </div>
  );
};

export default Recognition;
